import { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductDetailsIngredientContentContainer = (props: Props) => {
  const { children } = props;

  const { match } = useResponsive();

  const containerStyles = [styles.container, match([undefined, styles.containerSM])];

  return <View style={containerStyles}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexShrink: 1,
    gap: theme.spacing['4'],
  },
  containerSM: {
    maxWidth: 200,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
